import { Component } from '@angular/core';

@Component({
  selector: 'app-interviewcalls',
  templateUrl: './interviewcalls.component.html',
  styleUrls: ['./interviewcalls.component.scss']
})
export class InterviewcallsComponent {

}
